// Measure dynamic row height, except in firefox because it measures table border height incorrectly
export const getMeasureElement = () =>
  typeof window !== 'undefined' && navigator.userAgent.indexOf('Firefox') === -1
    ? (element: Element) => element.getBoundingClientRect().height
    : undefined
